import { render, staticRenderFns } from "./DoronPurchaseForm.vue?vue&type=template&id=76e47dde&scoped=true&"
import script from "./DoronPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./DoronPurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./DoronPurchaseForm.vue?vue&type=style&index=0&id=76e47dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e47dde",
  null
  
)

export default component.exports